import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import axiosInstance from "../../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../../constants";
import Loader from "../../components/loader";
import Table from "../../components/tables/table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { userFieldsData } from "../../data/TableData";
// import useUser from "../../hooks/useUser";


const MODULE_URI = "/user/userListing";
const FETCH_API_URL = `users/getuserslisting?`;
const CHANGE_STATUS_API_URL = `customer/change-customer-status?dataId=`;
export default function UserListing() {
  
  const [searchParams, setSearchParams] = useSearchParams();
  const userUpdate = searchParams.get("userUpdate");

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [totalCount, setTotalCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [addUpdate, setAddUpdate] = useState(false);

  
//   const { modulePermissions } = useUser(MODULE_URI);
//   const [resData, error, loading, axiosFetch, totalCount] = useAxios();
//   const [getStatus, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();
  const [resStatusData, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();

  const [resData, error, loading, axiosFetch] = useAxios();


  

  useEffect(() => {
    if (userUpdate === "success") {
      toast.success("user updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (userUpdate === "register") {
      toast.success("User Added successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [userUpdate]);

  const getData = (url) => {
    axiosFetch({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  // alert function
  // function handleStatus(id, index, flag) {
  //   const tableItem = tableData[index];

  //   let status = "B";
  //   let dialogTitle = "Update Customer";
  //   let btnLabel = "Update Customer";

  //   if (tableItem !== undefined && tableItem?.status !== undefined) {
  //     if (tableItem.status === "B") {
  //       status = "A";
  //       btnLabel = flag ? "Activate Customer" : "Unblock Customer";
  //     } else if (tableItem.status === "A") {
  //       status = flag ? "I" : "B";
  //       btnLabel =
  //         status === "I" ? "Deactivate Customer" : "Block Customer";
  //     } else if (tableItem.status === "I") {
  //       status = flag ? "A" : "B";
  //       btnLabel = status === "A" ? "Activate Customer" : "Block Customer";
  //     }
  //   }

  //   confirmAlert({
  //     title: dialogTitle,
  //     message: `Are you sure you want to ${btnLabel}?`,
  //     buttons: [
  //       {
  //         label: btnLabel,
  //         onClick: () => {
  //           handleStatusUpdate(id, status).then(() => {
  //             toast.success(`${btnLabel} successfully`, {
  //               position: toast.POSITION.TOP_RIGHT,
  //             });
  //           });
  //         },
  //       },
  //       {
  //         label: "Cancel",
  //       },
  //     ],
  //   });
  // }

  // const handleStatusUpdate = async (id, status) => {
  //   const statusURL = `${CHANGE_STATUS_API_URL}${id}`;

  //   // Changing Customer Status
  //     await axiosFetchStatus({
  //     axiosInstance: axiosInstance,
  //     url: statusURL,
  //     method: "POST",
  //     requestConfig: {
  //       data: {
  //         status,
  //       },
  //     },
  //   });

//     // Refresing Customer Data
//     // getData(
//     //   `${FETCH_API_URL}&search=${search}&skip=${
//     //     page > 0 ? page * limit : 0
//     //   }&limit=${limit}`
//     // );
//   };
//   console.log("resr data",resData)

  function navigateToEditPage(rowIndex ) {
    console.log("test row index",tableData[rowIndex])
    if (rowIndex >= 0) {
      const currItem = tableData[rowIndex];
      navigate(`${MODULE_URI}/edit/${currItem?._id}`);
    } else {
      navigate(MODULE_URI);
    }
  }
 

  useEffect(() => {
   
    getData(`${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`)

  }, [FETCH_API_URL,loadingStatus,search, page, limit]);


  useEffect(() => {
    if (resData?.[0]?.success !== false && resData.length > 0) {
      setTotalCount(resData?.[0]?.totalCount)

      const tempData = resData?.[0]?.data.map((item) => {
          return {
            _id: item._id,
            username: item.username,
            phone: item.phone,
            email: item.email,
            age: item.age,
            status: item.status
          
          };
        
      });
      setTableData(tempData);
    } else {
      if( resData?.[0]?.success === false) {
      toast.error("No data found", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
      setTableData([]);
      setTotalCount(0)

    }
  }, [resData]);

function navigateToUserBookSlot(rowIndex) {
    if (rowIndex >= 0) {
      
      const currItem = tableData[rowIndex];
      navigate(`${MODULE_URI}/userbookslot/${currItem?._id}`);
    } else {
      navigate(MODULE_URI);
    }
  }
  const handleStatus = async (rId, status,id) => {
    await axiosFetchStatus({
      axiosInstance: axiosInstance,
      url: `users/updateUserStatusData/${rId}`,
      method: "POST",
      requestConfig: {
        data: {
          status,
        },
      },
    });
    setAddUpdate(true);

   
  };

  return (
    <>
    <div className="card min-height-100">
      <div className="pump-report-top">
        <h2>User List</h2>
        <ToastContainer />

        <div className="btn-wrapper">
          {modulePermissions?.canAdd && (
            <Link
              to={`${MODULE_URI}/add`}
              className="btn btn-sm btn-navy-blue rounded-10"
            >
              Add User
            </Link>
          )}

          {/* {modulePermissions.canDownload && (
            <button className="btn btn-sm btn-green rounded-10">
              Download Data
            </button>
          )} */}
        </div>
      </div>

      {/* {loading && <Loader />} */}

      {/* {!loading && error && (
        <div className="label label-block label-red-bg rounded-10 mt-10 mb-10">
          {error || "Something went wrong!!"}
        </div>
      )} */}

      <div className="pump-search">
        <span className="text-gray">
          {" "}
          Show Entries
          <select
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            onChange={handleLimitChange}
          >
            {PAGE_LIMITS.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </span>

        <span>
          {" "}
          <input
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            placeholder="Search"
            onKeyDown={handleSearchFieldChange}
          />
        </span>
      </div>
      <div className="company-table ">
        <Table
          tableColumns={userFieldsData}
          tableData={tableData}
          tableSettings={{
            page,
            pageSize: limit,
            totalCount,
          }}
          action={true}
          modulePermissions= { modulePermissions }
          handleStatus={handleStatus}
          handleEdit={navigateToEditPage}
        //   handleCustAsset = {navigateToCustAssetPage}
          handlePage={setPage}
          handleUserBookSlotFlag = {true}
          handleUserBookSlot = {navigateToUserBookSlot}
        />
      </div>
    </div>
    </>
    
  );
}
